import { TreatmentDemoVideoStatus } from './treatment-demo-video-status.enum';

export interface TreatmentDemoVideoMetadata {
    treatmentId: string;
    id: number;
    assigneeId?: string;
    status: TreatmentDemoVideoStatus;
    demoVideoFileIds: number[];
}

export type TreatmentDemoVideoMetadataEntries = TreatmentDemoVideoMetadata[];
